import { faCircle } from "@fortawesome/pro-solid-svg-icons";
import { Link, useNavigate } from "react-router-dom";

import { ROUTE_CONFIG } from "@/routes/config";

import { Icon } from "../Icon/Icon";
import { Button } from "../Button/Button";

export const NoSenderModal = () => {
	const navigate = useNavigate();

	return (
		<div className="absolute z-30 left-0 top-0 pt-4 w-full min-h-full flex items-center justify-center">
			<div className="flex flex-col bg-white px-6 py-10 rounded-[20px] w-[656px] max-w-[100%] shadow-[0px_0px_80px_0px_rgba(171,178,217,0.35)] items-center justify-center mb-6">
				<div className="flex flex-col justify-center items-center gap-2">
					<div className="text-md font-bold mb-8">No senders set up yet</div>

					<div className="text-sm max-w-[500px] rounded-lg px-6 py-3 bg-background-warning mb-4">
						<b>To get started, you’ll need to configure at least one LinkedIn or email sender.</b>
						<ul className="list-disc mt-1 ml-1 gap-2 flex flex-col">
							<li className="flex items-start gap-2">
								<Icon className="text-text-meta w-1 h-1 mt-1.5" icon={faCircle} />{" "}
								<span className="flex items-center gap-1">
									Go to the <b>Users</b>
									page.
								</span>
							</li>
							<li className="flex items-start gap-2">
								<Icon className="text-text-meta w-1 h-1 mt-1.5" icon={faCircle} />{" "}
								<span>
									For <b>LinkedIn</b>, turn on <b>Connect Accounts</b> and make sure at least one
									user is signed in to LinkedIn.
								</span>
							</li>
							<li className="flex items-start gap-2">
								<Icon className="text-text-meta w-1 h-1 mt-1.5" icon={faCircle} />{" "}
								<span>
									For <b>Email</b>, add an email address to at least one user.
								</span>
							</li>
						</ul>
					</div>
					<div className="flex flex-row gap-2 mb-4">
						<div className="text-smd max-w-[300px] flex flex-col items-center gap-2 text-center px-4 py-3">
							<p>
								<b>When you&apos;re done, come back here to continue.</b>
							</p>
						</div>
					</div>

					<div className="w-auto">
						<Button
							title="Go to users page"
							onClick={() => {
								navigate(ROUTE_CONFIG.USERS);
							}}
						/>
					</div>
				</div>
			</div>
		</div>
	);
};
